module.exports = __webpack_public_path__ + "img/domclick-logo.0940a14f.svg";